import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import MainStoreRoute from './components/MainStoreRoute';
import MainMenu from './components/MainMenu';
import STOImport from './components/STOImport';
import STOList from './components/STOList';
import RecallImport from './components/RecallImport';
import RecallList from './components/RecallList';
import Inventory from './components/Inventory';
import Delivery from './components/Delivery';
import Reports from './components/Reports';
import VarianceReport from './components/VarianceReport';
import RecallReport from './components/RecallReport';
import FailedPickReport from './components/FailedPickReport';
import CycleCountReport from './components/CycleCountReport';
import ReturnsReport from './components/ReturnsReport';
import QCReport from './components/QCReport';
import OrderPickingReport from './components/OrderPickingReport';
import StockReport from './components/StockReport';
import PickListLanding from './components/PickListLanding';
import PickListImport from './components/PickListImport';
import PickListList from './components/PickListList';
import PickListDashboard from './components/PickListDashboard';
import AdminLocations from './components/AdminLocations';
import AdminUsers from './components/AdminUsers';
import CustomersLanding from './components/CustomersLanding';
import CustomersImport from './components/CustomersImport';
import CustomersList from './components/CustomersList';
import Login from './components/Login';
import Register from './components/Register';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainMenu />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sto-import"
              element={
                <ProtectedRoute>
                  <STOImport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sto-list"
              element={
                <ProtectedRoute>
                  <STOList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recall-import"
              element={
                <ProtectedRoute>
                  <RecallImport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recall-list"
              element={
                <ProtectedRoute>
                  <RecallList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <ProtectedRoute>
                  <Inventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delivery"
              element={
                <ProtectedRoute>
                  <Delivery />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/variance"
              element={
                <ProtectedRoute>
                  <VarianceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/recall"
              element={
                <ProtectedRoute>
                  <RecallReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/failed-picks"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <FailedPickReport />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/cycle-count"
              element={
                <ProtectedRoute>
                  <CycleCountReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/returns"
              element={
                <ProtectedRoute>
                  <ReturnsReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/qc"
              element={
                <ProtectedRoute>
                  <QCReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/order-picking"
              element={
                <ProtectedRoute>
                  <OrderPickingReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/stock"
              element={
                <ProtectedRoute>
                  <StockReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pick-list"
              element={
                <ProtectedRoute>
                  <MainStoreRoute>
                    <PickListLanding />
                  </MainStoreRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pick-list/import"
              element={
                <ProtectedRoute>
                  <MainStoreRoute>
                    <PickListImport />
                  </MainStoreRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pick-list/list"
              element={
                <ProtectedRoute>
                  <MainStoreRoute>
                    <PickListList />
                  </MainStoreRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pick-list/dashboard"
              element={
                <ProtectedRoute>
                  <MainStoreRoute>
                    <PickListDashboard />
                  </MainStoreRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/customers"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <CustomersLanding />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/customers/import"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <CustomersImport />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/customers/list"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <CustomersList />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/locations"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <AdminLocations />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <AdminUsers />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
